module.exports = __webpack_public_path__ + "img/39ne.59aec44d.svg";